var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "n6p9CK.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.5,293.9C69.8,294,4.7,229.3,4.5,149.6C4.3,69.3,69.5,3.8,149.3,4.1c80.5,0.3,145.3,65.2,145.2,145.3 C294.4,229.3,229.6,293.8,149.5,293.9z M163.8,106.7c0-9.8,0-19.7,0-29.5c0-8.5-6.2-14.9-14.2-15c-8.1-0.1-14.4,6.5-14.5,15.1 c0,23.7,0,47.3,0,71c0,6.6,2.9,11.2,8.7,14.1c4.9,2.5,9.9,4.9,14.8,7.4c14,7,28,14.1,42.1,21c10.1,4.9,21.2-2.1,20.9-13 c-0.2-6.2-3.3-10.3-8.8-13c-15.5-7.7-30.9-15.5-46.4-23.1c-2.2-1.1-2.8-2.3-2.8-4.6C163.9,126.8,163.8,116.8,163.8,106.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHora);
export default __webpack_public_path__ + "static/media/hora.ad32537ba1f5a6035c17234c2cd07498.svg";
export { ForwardRef as ReactComponent };